import { Clock, ShieldAlert, Users, EyeOff, UserCog, Workflow, ArrowRight } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { useLanguage } from "@/i18n";

const ICONS = [Clock, ShieldAlert, Users, EyeOff, UserCog, Workflow];

export default function Problems() {
    const { t } = useLanguage();

    return (
        <section id="problemi" data-testid="problems-section" className="relative scroll-mt-20">
            <div className="mx-auto max-w-7xl px-6 py-24 lg:px-10 lg:py-32">
                <SectionHeading
                    chapter={t.problems.chapter}
                    eyebrow={t.problems.eyebrow}
                    title={t.problems.title}
                    testid="problems-heading"
                />

                <div className="grid gap-px border border-navy-600 bg-navy-600 sm:grid-cols-2 lg:grid-cols-3">
                    {t.problems.items.map((q, i) => {
                        const Icon = ICONS[i];
                        return (
                            <Reveal key={i} delay={i * 0.06} className="h-full">
                                <div
                                    data-testid={`problem-card-${i + 1}`}
                                    className="group h-full bg-navy-950 p-6 transition-colors hover:bg-navy-900"
                                >
                                    <div className="mb-6 flex items-center justify-between">
                                        <Icon className="h-5 w-5 text-sky-400" />
                                        <span className="font-mono text-[11px] tracking-widest text-slate-600">
                                            P.0{i + 1}
                                        </span>
                                    </div>
                                    <p className="text-base font-medium leading-snug text-slate-100 sm:text-lg">{q}</p>
                                </div>
                            </Reveal>
                        );
                    })}
                </div>

                <Reveal delay={0.1}>
                    <div
                        data-testid="problems-conclusion"
                        className="mt-6 flex flex-col gap-6 bg-[#081627] p-8 sm:flex-row sm:items-center sm:justify-between lg:p-10"
                    >
                        <p className="max-w-2xl font-display text-lg font-semibold text-white sm:text-xl">
                            {t.problems.conclusionA}{" "}
                            <span className="text-[#5B8DEF]">{t.problems.conclusionB}</span>
                        </p>
                        <a
                            href="#contatti"
                            data-testid="problems-cta"
                            className="group inline-flex w-fit shrink-0 items-center gap-2 bg-sky-400 px-6 py-3 font-mono text-xs font-bold uppercase tracking-widest text-white transition-colors hover:bg-sky-500"
                        >
                            {t.problems.cta}
                            <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                        </a>
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
